export enum CommsTypes {
  GET_COMMS_BY_SITECODE = "GET_COMMS_BY_SITECODE",
  GET_COMMS_BY_SITECODE_SUCCESS = 'GET_COMMS_BY_SITECODE_SUCCESS',
  GET_COMMS_BY_SITECODE_FAIL = 'GET_COMMS_BY_SITECODE_FAIL',

  SAVE_COMMS = 'SAVE_COMMS',
  SAVE_COMMS_SUCCESS = 'SAVE_COMMS_SUCCESS',
}
